// extracted by mini-css-extract-plugin
module.exports = {"tbody":"TableBody_tbody__31WX4"};